'use client';
import { useIsLG, useIsMD, useIsXL } from '@repo/ui/src/utils/useMediaQuery';
import { ImageProps } from '@repo/ui/src/types/image';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { appConfig } from '@repo/ui/src/utils/appConfig';

export interface FeatureCardProps {
  toutContent: ToutContentProps;
  backgroundImage: ImageProps;
  alt?: string;
  isActive?: boolean;
  index?: number;
  totalSlides?: number;
}

const FeatureCarouselCard = ({
  toutContent,
  backgroundImage,
  isActive = false,
  index = 0,
  totalSlides = 1,
}: FeatureCardProps) => {
  const lgAndUp = useIsXL();
  const mdAndUp = useIsLG();
  const smAndUp = useIsMD();
  const isMeater = appConfig.isMeater;

  const backgroundImageUrl = lgAndUp
    ? buildImageSrc(backgroundImage, 1500, 9, 5)
    : mdAndUp
      ? buildImageSrc(backgroundImage, 1280, 7, 5)
      : smAndUp
        ? buildImageSrc(backgroundImage, 960, 1, 1)
        : buildImageSrc(backgroundImage, 600, 1, 1);

  return (
    <div
      className="focus:tw-outline-brand-400 tw-relative"
      tabIndex={-1}
      aria-hidden={!isActive}
      role="group"
      aria-label={`slide ${index + 1} of ${totalSlides}`}
    >
      <div
        className="tw-relative tw-w-full tw-h-[646px] tw-bg-cover tw-bg-center tw-flex tw-items-end tw-px-[40px] tw-py-[25px]"
        style={{
          backgroundImage: `url(${backgroundImageUrl})`,
        }}
      >
        {/* Gradient overlay */}
        <div
          className="tw-absolute tw-inset-0 tw-pointer-events-none"
          style={{
            background: isMeater
              ? 'linear-gradient(to right, rgba(0, 0, 0, 0.71), rgba(0, 0, 0, 0.25), rgba(255, 255, 255, 0))'
              : 'linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)',
          }}
        />

        <div className="tw-relative tw-z-10 tw-flex tw-flex-col tw-gap-[15px] tw-max-w-[500px]">
          <h3 className="tra-text-web-heading-3 tw-uppercase tw-text-white">
            {toutContent?.heading}
          </h3>
          {toutContent?.description && (
            <p className="tra-text-web-body-l tw-text-white">{toutContent.description}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeatureCarouselCard;
